import { Component, OnInit, OnDestroy, ViewChild, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { SwiperConfigInterface, SwiperComponent, SwiperDirective } from 'ngx-swiper-wrapper';
import { RoleService } from 'src/app/services/role.service';
import { TeamService } from 'src/app/services/team.service';
import { SponsorsService } from 'src/app/services/sponsors.service';
import { CategoryService } from 'src/app/services/category.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LazyLoadEvent } from "primeng/api";
import { FeaturedThisWeekService } from "src/app/services/featured-this-week.service";
import { NewsService } from "src/app/services/news.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
import { FounderAndAdvisorService } from 'src/app/services/founder-and-advisor.service';

@Component({
  selector: 'app-abouttheleague',
  templateUrl: './abouttheleague.component.html',
  styleUrls: ['./abouttheleague.component.scss']
})

export class AbouttheleagueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  public downloadModal: boolean = false;
  tplNews: any[] = [];
  featureList: any[] = [];
  private lazyLoadEvent: LazyLoadEvent;
  public disabled: boolean = false;
  public loading: boolean;
  public errorMessage: string;
  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    effect: 'slide',
    speed: 600,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 0
      }
    }
  };
  featureListSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 2.15,
        spaceBetween: 10,
        autoplay: false,
      },
      400: {
        slidesPerView: 2.3,
        spaceBetween: 10,
        autoplay: false,
      },

      767: {
        slidesPerView: 2.3,
        spaceBetween: 0,

      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,

      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
    },
  };
  teamSlider = {
    effect: 'slide',
    slidesPerView: 4,
    spaceBetween: 0,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
  };
  sponserSlider = {
    effect: 'slide',
    slidesPerView: 4,
    spaceBetween: 0,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 4,
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
  };
  newsSlider = {
    effect: 'slide',
    slidesPerView: 3,
    spaceBetween: 20,  // Adjust spacing as needed
    loop: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      370: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      767: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
        centeredSlides: false,
      },
      993: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
      },
    },
  };
  public teamList: any[] = [];
  pointsTableDataDetails: any;
  @ViewChild(SwiperComponent) componentRef?: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef?: SwiperDirective;
  sponsorsData: any[] = [];
  categorylist: any[] = [];
  groupedSponsors: any[] = []; 
  public cmsContent;
  public cmsContentData;
  boardAndAdvisorsData: any;
  constructor(private cmsmoduleService: CmsmoduleService, private founderAndAdvisorService: FounderAndAdvisorService, private newsService: NewsService, private featuredThisWeekService: FeaturedThisWeekService, private teamService: TeamService, private router: Router, private renderer: Renderer2, private roleService: RoleService, private categoryService: CategoryService, private sponsorsService: SponsorsService) { }

  ngOnInit(): void {
    this.getCmsContent();
    this.getBoardAdvisorData();
    this.getTplNews();
    this.loadFeaturedThisWeekList(this.lazyLoadEvent);
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.renderer.addClass(document.body, "aboutUsPage");
    this.getTeams();
    this.loadSponsorsAndCategories();
    this.getAllTeamsPointsTable();
  }

   getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=abouttheleague";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];        
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.cmsContent['cmsDescription'];
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

   getBoardAdvisorData() {
    var query = "?filterByDisable=false&filterByStatus=true";
    this.founderAndAdvisorService.getFounderAndAdvisors(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
        this.loading = false;
        this.boardAndAdvisorsData = data.data.items;
        console.log(data.data.items);
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  getTplNews() {
    var query = "?filterByDisable=false&filterByStatus=true";
    this.newsService.getNewsList(query).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.loading = false;
      if (data.data.totalCount > 0) {
        this.tplNews = data.data.items.map((item: any) => ({
          heading: item.title,
          link: item.url,
          src: item.newsImage,
          channelName: item.channelName,
          createdAt: item.created_at
        }));
      }
    },
      (err) => {
        this.errorMessage = err.error.message;
      });
  }

  loadSponsorsAndCategories() {
    const sponsorsQuery = '?filterByDisable=false';
    const categoriesQuery = '?filterByDisable=false&getSubcategory=true&pageSize=50&pageNumber=1&filterByParentCategory=Sponsors&filterByname=Official Partners';
    // Use forkJoin so both requests are available together
    forkJoin({
      sponsorsResp: this.sponsorsService.getSponsors(sponsorsQuery).pipe(
        catchError(err => {
          console.error('Sponsors API error', err);
          return of(null);
        })
      ),
      categoriesResp: this.categoryService.getCategoryWithoutAuthList(categoriesQuery).pipe(
        catchError(err => {
          console.error('Categories API error', err);
          return of(null);
        })
      )
    }).pipe(takeUntil(this.destroy$)).subscribe(({ sponsorsResp, categoriesResp }) => {
      this.sponsorsData = this.extractSponsorsArray(sponsorsResp);
      this.categorylist = this.extractCategoriesArray(categoriesResp);
      this.buildGroupedSponsors();
    });
  }

  extractSponsorsArray(resp: any): any[] {
    if (!resp) return [];
    // common patterns: resp.items.items OR resp.data.items OR resp.items
    if (Array.isArray(resp)) return resp;
    if (resp.items && Array.isArray(resp.items.items)) return resp.items.items;
    if (resp.data && Array.isArray(resp.data.items)) return resp.data.items;
    if (resp.items && Array.isArray(resp.items)) return resp.items;
    // fallback: whatever top-level array exists
    const arr = Object.values(resp).find(v => Array.isArray(v));
    return Array.isArray(arr) ? arr : [];
  }

  extractCategoriesArray(resp: any): any[] {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;
    if (resp.data && Array.isArray(resp.data.items)) return resp.data.items;
    if (resp.items && Array.isArray(resp.items)) return resp.items;
    const arr = Object.values(resp).find(v => Array.isArray(v));
    return Array.isArray(arr) ? arr : [];
  }

  // Get category id from sponsor — handle string or object
  getCategoryIdFromSponsor(sponsor: any): string | null {
    if (!sponsor) return null;
    // the category might be a string id or an object like { _id: '...', title: '...' }
    if (typeof sponsor.category === 'string' && sponsor.category.trim()) return sponsor.category;
    if (sponsor.category && typeof sponsor.category === 'object') {
      // common keys: _id, id
      return sponsor.category._id || sponsor.category.id || null;
    }
    // sometimes sponsor has categoryId field
    if (sponsor.categoryId) return sponsor.categoryId;
    return null;
  }

  hasSponsorLink(sponsor: any): boolean {
    const link = sponsor?.link;
    return typeof link === 'string' && link.trim().length > 0;
  }

  getSponsorLink(sponsor: any): string {
    const link = sponsor?.link;
    return typeof link === 'string' ? link.trim() : '';
  }

  buildGroupedSponsors() {
    // Build map: id -> meta
    const categoryMap: Record<string, { name: string; image?: string }> = {};
    this.categorylist.forEach(cat => {
      const id = cat._id || cat.id || cat._id?.toString();
      if (!id) return;
      categoryMap[id] = {
        name: cat.title || cat.name || 'Unnamed',
        image: cat.photo || cat.icon || cat.image || null
      };
    });
    // Keep order as returned by categorylist (IDs)
    const categoryOrder = this.categorylist.map(c => c._id || c.id).filter(Boolean);
    const groupedById: Record<string, any> = {}; // key = categoryId or 'others'
    this.sponsorsData.forEach(sponsor => {
      const catId = this.getCategoryIdFromSponsor(sponsor);
      const useId = catId || '__OTHERS__';
      if (!groupedById[useId]) {
        const meta = categoryMap[useId];
        groupedById[useId] = {
          categoryId: useId === '__OTHERS__' ? null : useId,
          categoryName: meta ? meta.name : (useId === '__OTHERS__' ? 'Others' : (sponsor?.category?.title || 'Unknown')),
          categoryImage: meta ? meta.image : null,
          sponsors: []
        };
      }
      groupedById[useId].sponsors.push(sponsor);
    });
    // Convert to array and sort by categoryOrder (with Others at the end)
    const groupedArray = Object.values(groupedById) as any[];
    groupedArray.sort((a, b) => {
      if (!a.categoryId) return 1;
      if (!b.categoryId) return -1;
      const iA = categoryOrder.indexOf(a.categoryId);
      const iB = categoryOrder.indexOf(b.categoryId);
      return iB - iA;   //  DESC SORT
    });
    this.groupedSponsors = groupedArray;
  }

  getTeams() {
    let query = "?filterByDisable=false&filterByStatus=true";
    this.teamService.getTeamListWithoutAuth(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        this.teamList = data.data.items;
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  public onIndexChange(index: number): void {
    // console.log('Swiper index: ', index);
  }

  public onSwiperEvent(event: string): void {
    // console.log('Swiper event: ', event);
  }

  loadFeaturedThisWeekList(event: LazyLoadEvent) {
    let query = "?filterByDisable=false";
    let pagenumber = 1;
    let params = "";
    let rows = 10;
    if (event !== undefined) {
      if (event.first != undefined && event.first == 0) {
        pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
        pagenumber = (event.first / event.rows) + 1;
      } else {
        pagenumber = 1;
      }
      if (event.rows != undefined) {
        rows = event.rows;
      } else {
        rows = 10;
      }
    }
    if (params != undefined && params != "") {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    } else {
      query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    }
    this.featuredThisWeekService.getFeaturedThisWeek(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.featureList = data.items.items;
    }, (error) => {
    })
  }
  getAllTeamsPointsTable() {    
    let query = `?pageLimit=1&pageSize=1`;
    let pagenumber = 1;
    let params = "";
    let rows = 10;

    this.teamService.getV1PointsTable(query).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.pointsTableDataDetails = data?.data?.items?.[0]?.pointsTableData;;
      //console.log(this.pointsTableDataDetails);

    }, (err) => {

    });
  }

  onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright') {
    this.position = position;
    this.downloadModal = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.renderer.removeClass(document.body, 'aboutUsPage');
  }

}
